import { render, staticRenderFns } from "./DataAirModel.vue?vue&type=template&id=a3242148&scoped=true"
import script from "./DataAirModel.vue?vue&type=script&lang=js"
export * from "./DataAirModel.vue?vue&type=script&lang=js"
import style0 from "./DataAirModel.vue?vue&type=style&index=0&id=a3242148&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3242148",
  null
  
)

export default component.exports